<template>
  <div id="lyauth">
    <img src="../../assets/ly.png" id="lylogo" />
    <h2 id="lyh2">来源电子司机端</h2>
  </div>
</template>
<script>
import axios from "axios";
import * as dd from "dingtalk-jsapi"; // 此方式为整体加载，也可按需进行加载
export default {
  data() {
    return {};
  },
  methods: {
    dddd() {
      var that = this;
      dd.runtime.permission.requestAuthCode({
        //corpId: "dinge45fff381270af044ac5d6980864d335",
        corpId: "ding360db96270e77c12a1320dcb25e91351",
        onSuccess: function (res) {
          // 调用成功时回调
          that.authCode(res.code);
        },
        onFail: function (err) {
          // 调用失败时回调
          console.log(err);
        },
      });
    },
    authCode(authCode) {
      axios({
        method: "get",
        url:
          "http://106.53.93.140:7090/user/getUserInfo?authCode=" +
          authCode +
          "&app=2",
        data: {},
      }).then((res) => {
        var aaa = JSON.stringify(res);
        //alert(aaa);
        var data = res.data.data;
        var text = "电话：" + data.mobile + "，用户id：" + data.userid;
        //alert(text);
        this.gethref(data.mobile, data.userid);
      });
    },
    gethref(mobile, userid) {
      //alert('mobile:'+mobile+'userid:'+userid);
      var params = {
        mobile: mobile,
        userId: userid,
        apiKey: "abc41386-ba37-438c-899a-8fbfabebf6eb",
      };
      axios({
        method: "post",
        //url: "http://106.53.93.140:8801/gps-customer-server-dingtalk/auth/driver",
        url: "http://106.53.93.140:8801/gps-customer-server-dingtalk/auth/user",
        data: params,
      })
        .then((res) => {
          var aaa = JSON.stringify(res);
          //alert(aaa);
          var myData = res.data.data;
          if (res.data.code == 200) {
            var obj = {
              token: myData.token,
              identityId: myData.identityId,
              share: myData.share,
            };
            // console.log(obj);
            localStorage.setItem("driverLogin", JSON.stringify(obj));
            this.$router.push({
              path: "/home",
            });
          } else {
            this.$Message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted() {
    setTimeout(() => {
      this.dddd();
      //this.gethref('18269013230','3333333');
    }, 700);
  },
};
</script>
<style lang="">
#lyauth {
  text-align: center;
}
#lylogo {
  width: 100px;
  margin-top: 200px;
}
#lyh2 {
  font-weight: lighter;
  font-size: 18px;
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/auth.vue